import "app/static/stylus/form-step.styl"
import React from "react"
import { Col } from "react-bootstrap"

class FormStepLabel extends React.Component {
    static initClass() {
        this.defaultProps = {
            radius: 25,
            strokeWidth: 0,
            // stroke: "#503ABD"
            fill: "#503ABD",
            step: null,
        }
    }
    render() {
        const size = (this.props.strokeWidth + this.props.radius) * 2
        return (
            <Col
                md={2}
                xs={12}
                className={`form-step-label text-center use-counter ${this.props.step && "use-manual-counter"}`}
                step={this.props.step}
            >
                <svg width={size} height={size}>
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={this.props.radius}
                        stroke={this.props.stroke}
                        strokeWidth={this.props.strokeWidth}
                        fill={this.props.fill}
                    />
                </svg>
                <Col md={12} className={`form-step-label-text`}>
                    <span className="label-text" dangerouslySetInnerHTML={{ __html: this.props.label }} />
                    {this.props.tooltip ? this.props.tooltip : null}
                </Col>
            </Col>
        )
    }
}
FormStepLabel.initClass()

class FormStep extends React.Component {
    render() {
        return (
            <div
                className={`${this.props.overrideFormStepClass ? "" : "form-step"} ${
                    this.props.center ? "form-step-centered" : ""
                }`}
            >
                <FormStepLabel {...Object.assign({}, this.props)} />
                <Col md={this.props.stepSize || 9} xs={12}>
                    {this.props.children}
                </Col>
            </div>
        )
    }
}

export default FormStep
